import React from 'react';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    page: {
      flexDirection: 'column',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      alignItems: "center"
    },
    sectFiH: {
        height: 2,
        backgroundColor: "#282c34"
    },
    sectFi: {
        height: 50,
        backgroundColor: "#F07F3C"
    },
    sectSe: {
        height: 3,
        backgroundColor: "#F07F3C"
    },
    section1: {
        display: "flex",
        flexDirection: "column",
        marginTop: 10,
        alignItems: "center",
        height: "65%"
    },
    impSpo: {
        width: 20,
        margin: "auto"
    },
    sectSp: {
        margin: 10,
        padding: 10,
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        height: 50
    },
    sectSpM: {
        marginTop: 30,
        padding: 20,
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        height: 50
    },
    sectSpF: {
        margin: 10,
        padding: 10,
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        height: 60
    },
    sectSpF1: {
        width: "10%"
    },
    sectSp1: {
        width: "15%"
    },
    sectSpF2: {
        height: 20,
        width: "80%"
    },
    sectSp2: {
        height: 20,
        width: "70%"
    },
    sectSp3: {
        height: 50,
        width: "15%"
    },
    sectSp4: {
        height: 50,
        width: "20%"
    },
    sectSp5: {
        height: 50,
        width: "25%"
    },
    txtHead: {
        fontWeight: 'bold',
        marginTop: 20,
        fontFamily: 'Helvetica-Bold'
    },
    txtHeadF: {
        marginTop: 20,
        fontStyle: 'italic',
        fontFamily: 'Helvetica'
    },
    txtName: {
        marginTop: 20,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 5,
        width: "70%",
        height: 50,
        textAlign: "center",
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
        borderBottomColor: "#282c34",
        fontSize: 30,
        fontFamily: 'Helvetica'
    },
    txtNameC: {
        fontWeight: 'bold',
        marginTop: 20,
        fontSize: 25,
        fontFamily: 'Helvetica-Bold'
    },
    sectBF: {
        height: 50
    },
  });

export function PdfDocument(props) {
    styles.sectFi.backgroundColor = props.data.primary_color;
    styles.sectSe.backgroundColor = props.data.primary_color;
    const dataUrl = `data:image/png+xml;base64+xml;base64,${btoa(props.data.icon_text)}`
    // console.log({props})
    let nameCourse = props.data.name;
    if(props.data.course_name){
        nameCourse = props.data.course_name;
    }
    let name = props.name.toUpperCase()
    return (
    <Document>
        <Page size="A4" orientation="landscape">
            <View style={styles.sectFi}>
            </View>
            <View style={styles.sectSp}>
                <View style={styles.sectSp1}>
                    <Image src={props.imgSpT}/>
                </View>
                <View style={styles.sectSp2}>
                </View>
                <View style={styles.sectSp1}>
                    <Image src={props.imgSpTh}/>
                </View>
            </View>
            <View style={styles.sectFiH}>
            </View>
            <View style={styles.section1}>
        
                <Text style={styles.txtHead}>{props.transTxt.certificado.header1}</Text>
                <Text style={styles.txtHead}>{props.transTxt.certificado.header2}</Text>
                <Text style={styles.txtHeadF}>{props.transTxt.certificado.header3}</Text>
                <Text style={styles.txtName}>{name}</Text>
                <Text style={styles.txtHeadF}>{props.transTxt.certificado.header4}</Text>
                <Text style={styles.txtNameC}>{nameCourse}</Text>

                <View style={styles.sectSpM}>
                    <View style={styles.sectSp5}>
                    </View>
                    <View style={styles.sectSp3}>
                        <Image src={dataUrl}/>
                    </View>
                    <View style={styles.sectSp4}>
                    </View>
                    <View style={styles.sectSp3}>
                        <Image src={props.imgIco}/>
                    </View>
                    <View style={styles.sectSp5}>
                    </View>
                </View>
                <View style={styles.sectBF}>
                </View>

            </View>
            <View style={styles.sectSe}>
            </View>
            <View style={styles.sectSpF}>
                <View style={styles.sectSpF1}>
                    <Image src={props.imgSpO}/>
                </View>
                <View style={styles.sectSpF2}>
                </View>
                <View style={styles.sectSpF1}>
                    <Image src={props.imgSpF}/>
                </View>
            </View>
        </Page>
    </Document>
    );
}